<template>
  <div class="stockApp">
    <div class="stock">
      <main>
        <div class="mainBottom">
          <!-- 左侧菜单栏 -->
          <div class="left">
            <div class="leftBox">
              <el-menu unique-opened :default-openeds="openeds" :default-active="categoryId">
                <el-submenu index="one">
                  <template slot="title">
                    <span class="headline">化学制剂</span>
                  </template>
                  <el-menu-item index="1" @click="showPage('1')">化学药品制剂主要品种产量</el-menu-item>
                  <el-menu-item index="2" id="moreText" @click="showPage('2')">化学制药中间体品种产量、出口量</el-menu-item>
                  <el-menu-item index="3" id="moreText" @click="showPage('3')">化学原料药二十四大类品种产量、出口量</el-menu-item>
                </el-submenu>
                <!-- 中药生物制剂 -->
                <el-submenu index="two">
                  <template slot="title">
                    <span class="headline">中药生物制剂</span>
                  </template>
                  <el-menu-item index="4" @click="showPage('4')">中药生物制药主要品种产量</el-menu-item>
                </el-submenu>
                <!-- 医疗器械 -->
                <el-submenu index="three">
                  <template slot="title">
                    <span class="headline">医疗器械</span>
                  </template>
                  <el-menu-item index="5" @click="showPage('5')">医药器械主要品种产量</el-menu-item>
                  <el-menu-item index="6" id="moreText" @click="showPage('6')">NMPA批准的境内第三类医疗器械</el-menu-item>
                </el-submenu>
                <!-- 批准新药情况 -->
                <el-submenu index="four">
                  <template slot="title">
                    <span class="headline">批准新药情况</span>
                  </template>
                  <el-menu-item index="7" @click="showPage('7')">批准新药</el-menu-item>
                </el-submenu>
                <!-- 医药企业情况 -->
                <el-submenu index="five">
                  <template slot="title">
                    <span class="headline">医药企业情况</span>
                  </template>
                  <el-menu-item index="8" @click="showPage('8')">医药企业信息</el-menu-item>
                  <el-menu-item index="9" @click="showPage('9')">通过制剂国际认证的企业</el-menu-item>
                  <el-menu-item index="10" id="moreText" @click="showPage('10')">通过《药品生产质量管理规范》认证的企业</el-menu-item>
                </el-submenu>
              </el-menu>
            </div>
          </div>
          <!-- 右侧内容 -->
          <div class="right">
            <!-- 头部 -->
            <rightTop></rightTop>
            <div class="addRightBox" v-if="categoryId==1">
              <!--下载 -->
              <div class="rightCenter">
                <div class="centerTit">化学药品制剂主要品种产量</div>
                <div class="centerCon">
                  <div class="no">
                    <span></span>
                  </div>
                  <div class="excel" @click="downloadTable('1')">
                    <img src="@/assets/img/Excel.png" alt />
                    下载数据到Excel
                  </div>
                </div>
              </div>
              <!-- 表格 -->
              <div class="rightBottom">
                <div class="tabulationBottom">
                  <el-table :data="tableList" style="width: 100%" border size="mini">
                    <af-table-column prop="time" fixed label="时间"></af-table-column>
                    <af-table-column prop="type1" fixed label="分类1"></af-table-column>
                    <af-table-column prop="type2" fixed label="分类2"></af-table-column>
                    <af-table-column prop="productname" fixed label="产品名称"></af-table-column>
                    <af-table-column prop="department" fixed label="生产单位"></af-table-column>
                    <af-table-column prop="unifiedSocialCreditCode" label="统一社会信用代码"></af-table-column>
                    <af-table-column prop="spec" label="规格"></af-table-column>
                    <af-table-column prop="unit" label="计量单位"></af-table-column>
                    <af-table-column prop="output" label="产量"></af-table-column>
                  </el-table>
                </div>
              </div>
            </div>
            <div class="addRightBox" v-else-if="categoryId==2">
              <!--下载 -->
              <div class="rightCenter">
                <div class="centerTit">化学制药中间体品种产量、出口量</div>
                <div class="centerCon">
                  <div class="no">
                    <span></span>
                  </div>
                  <div class="excel" @click="downloadTable('2')">
                    <img src="@/assets/img/Excel.png" alt />
                    下载数据到Excel
                  </div>
                </div>
              </div>
              <!-- 表格 -->
              <div class="rightBottom">
                <div class="tabulationBottom">
                  <el-table :data="tableList" style="width: 100%" border size="mini">
                    <af-table-column prop="time" fixed label="时间"></af-table-column>
                    <af-table-column prop="productname" fixed label="产品名称"></af-table-column>
                    <af-table-column prop="department" fixed label="生产单位"></af-table-column>
                    <af-table-column prop="unifiedSocialCreditCode" label="统一社会信用代码"></af-table-column>
                    <af-table-column prop="output" label="产量(吨)"></af-table-column>
                    <af-table-column prop="export" label="出口量(吨)"></af-table-column>
                  </el-table>
                </div>
              </div>
            </div>
            <div class="addRightBox" v-else-if="categoryId==3">
              <!--下载 -->
              <div class="rightCenter">
                <div class="centerTit">化学原料药二十四大类品种产量、出口量</div>
                <div class="centerCon">
                  <div class="no">
                    <span></span>
                  </div>
                  <div class="excel" @click="downloadTable('3')">
                    <img src="@/assets/img/Excel.png" alt />
                    下载数据到Excel
                  </div>
                </div>
              </div>
              <!-- 表格 -->
              <div class="rightBottom">
                <div class="tabulationBottom">
                  <el-table :data="tableList" style="width: 100%" border size="mini">
                    <af-table-column prop="time" fixed label="时间"></af-table-column>
                    <af-table-column prop="type" fixed label="品种"></af-table-column>
                    <af-table-column prop="productname" fixed label="产品名称"></af-table-column>
                    <af-table-column prop="department" fixed label="生产单位"></af-table-column>
                    <af-table-column prop="unifiedSocialCreditCode" label="统一社会信用代码"></af-table-column>
                    <af-table-column prop="output" label="产量(吨)"></af-table-column>
                    <af-table-column prop="export" label="出口量(吨)"></af-table-column>
                  </el-table>
                </div>
              </div>
            </div>
            <div class="addRightBox" v-else-if="categoryId==4">
              <!--下载 -->
              <div class="rightCenter">
                <div class="centerTit">中药生物制药主要品种产量</div>
                <div class="centerCon">
                  <div class="no">
                    <span></span>
                  </div>
                  <div class="excel" @click="downloadTable('4')">
                    <img src="@/assets/img/Excel.png" alt />
                    下载数据到Excel
                  </div>
                </div>
              </div>
              <!-- 表格 -->
              <div class="rightBottom">
                <div class="tabulationBottom">
                  <el-table :data="tableList" style="width: 100%" border size="mini">
                    <af-table-column prop="time" fixed label="时间"></af-table-column>
                    <af-table-column prop="type1" fixed label="分类1"></af-table-column>
                    <af-table-column prop="type2" fixed label="分类2"></af-table-column>
                    <af-table-column prop="productname" fixed label="产品名称"></af-table-column>
                    <af-table-column prop="department" fixed label="生产单位"></af-table-column>
                    <af-table-column prop="unifiedSocialCreditCode" label="统一社会信用代码"></af-table-column>
                    <af-table-column prop="form" label="规格"></af-table-column>
                    <af-table-column prop="unit" label="计量单位"></af-table-column>
                    <af-table-column prop="output" label="产量"></af-table-column>
                  </el-table>
                </div>
              </div>
            </div>
            <div class="addRightBox" v-else-if="categoryId==5">
              <!--下载 -->
              <div class="rightCenter">
                <div class="centerTit">医药器械主要品种产量</div>
                <div class="centerCon">
                  <div class="no">
                    <span></span>
                  </div>
                  <div class="excel" @click="downloadTable('5')">
                    <img src="@/assets/img/Excel.png" alt />
                    下载数据到Excel
                  </div>
                </div>
              </div>
              <!-- 表格 -->
              <div class="rightBottom">
                <div class="tabulationBottom">
                  <el-table :data="tableList" style="width: 100%" border size="mini">
                    <af-table-column prop="time" fixed label="时间"></af-table-column>
                    <af-table-column prop="productname" fixed label="产品名称"></af-table-column>
                    <af-table-column prop="department" fixed label="生产单位"></af-table-column>
                    <af-table-column prop="unifiedSocialCreditCode" label="统一社会信用代码"></af-table-column>
                    <af-table-column prop="form" label="规格"></af-table-column>
                    <af-table-column prop="unit" label="计量单位"></af-table-column>
                    <af-table-column prop="output" label="产量"></af-table-column>
                  </el-table>
                </div>
              </div>
            </div>
            <div class="addRightBox" v-else-if="categoryId==6">
              <!--下载 -->
              <div class="rightCenter">
                <div class="centerTit">NMPA批准的境内第三类医疗器械</div>
                <div class="centerCon">
                  <div class="no">
                    <span></span>
                  </div>
                  <div class="excel" @click="downloadTable('6')">
                    <img src="@/assets/img/Excel.png" alt />
                    下载数据到Excel
                  </div>
                </div>
              </div>
              <!-- 表格 -->
              <div class="rightBottom">
                <div class="tabulationBottom">
                  <el-table :data="tableList" style="width: 100%" border size="mini">
                    <af-table-column prop="time" fixed label="时间"></af-table-column>
                    <af-table-column prop="guozi" fixed label="国食药监械(准)字"></af-table-column>
                    <af-table-column prop="productname" fixed label="产品名称"></af-table-column>
                    <af-table-column prop="department" label="生产单位"></af-table-column>
                    <af-table-column prop="unifiedSocialCreditCode" label="统一社会信用代码"></af-table-column>
                    <af-table-column prop="approvaldate" label="批准日期"></af-table-column>
                  </el-table>
                </div>
              </div>
            </div>
            <div class="addRightBox" v-else-if="categoryId==7">
              <!--下载 -->
              <div class="rightCenter">
                <div class="centerTit">批准新药</div>
                <div class="centerCon">
                  <div class="no">
                    <span></span>
                  </div>
                  <div class="excel" @click="downloadTable('7')">
                    <img src="@/assets/img/Excel.png" alt />
                    下载数据到Excel
                  </div>
                </div>
              </div>
              <!-- 表格 -->
              <div class="rightBottom">
                <div class="tabulationBottom">
                  <el-table :data="tableList" style="width: 100%" border size="mini">
                    <af-table-column prop="time" fixed label="时间"></af-table-column>
                    <af-table-column prop="type" fixed label="分类"></af-table-column>
                    <af-table-column prop="form" fixed label="剂型"></af-table-column>
                    <af-table-column prop="drugname" fixed label="药品名称"></af-table-column>
                    <af-table-column prop="level" label="类别"></af-table-column>
                    <af-table-column prop="guige" label="规格"></af-table-column>
                    <af-table-column prop="pijianhao" label="批件号"></af-table-column>
                    <af-table-column prop="guoyaozhengzi" label="国药证字"></af-table-column>
                    <af-table-column prop="guoyaozhunzi" label="国药准字"></af-table-column>
                    <af-table-column prop="guoyaoshizi" label="国药试字"></af-table-column>
                    <af-table-column prop="department" label="申请单位"></af-table-column>
                    <af-table-column prop="unifiedSocialCreditCode" label="统一社会信用代码"></af-table-column>
                    <af-table-column prop="approvaldate" label="批准日期"></af-table-column>
                  </el-table>
                </div>
              </div>
            </div>
            <div class="addRightBox" v-else-if="categoryId==8">
              <!--下载 -->
              <div class="rightCenter">
                <div class="centerTit">医药企业信息</div>
                <div class="centerCon">
                  <div class="no">
                    <span></span>
                  </div>
                  <div class="excel" @click="downloadTable('8')">
                    <img src="@/assets/img/Excel.png" alt />
                    下载数据到Excel
                  </div>
                </div>
              </div>
              <!-- 表格 -->
              <div class="rightBottom">
                <div class="tabulationBottom">
                  <el-table :data="tableList" style="width: 100%" border size="mini">
                    <af-table-column prop="time" fixed label="时间"></af-table-column>
                    <af-table-column prop="type" fixed label="类型"></af-table-column>
                    <af-table-column prop="region" fixed label="地区"></af-table-column>
                    <af-table-column prop="enterprise" fixed label="生产单位"></af-table-column>
                    <af-table-column prop="unifiedSocialCreditCode" label="统一社会信用代码"></af-table-column>
                    <af-table-column prop="address" label="单位地址"></af-table-column>
                    <af-table-column prop="zip" label="邮政编码"></af-table-column>
                    <af-table-column prop="phone" label="电话号码"></af-table-column>
                  </el-table>
                </div>
              </div>
            </div>
            <div class="addRightBox" v-else-if="categoryId==9">
              <!--下载 -->
              <div class="rightCenter">
                <div class="centerTit">通过制剂国际认证的企业</div>
                <div class="centerCon">
                  <div class="no">
                    <span></span>
                  </div>
                  <div class="excel" @click="downloadTable('9')">
                    <img src="@/assets/img/Excel.png" alt />
                    下载数据到Excel
                  </div>
                </div>
              </div>
              <!-- 表格 -->
              <div class="rightBottom">
                <div class="tabulationBottom">
                  <el-table :data="tableList" style="width: 100%" border size="mini">
                    <af-table-column prop="time" fixed label="时间"></af-table-column>
                    <af-table-column prop="certifiedtype" fixed label="认证类型"></af-table-column>
                    <af-table-column prop="enterprisename" fixed label="企业名称"></af-table-column>
                    <af-table-column prop="unifiedSocialCreditCode" label="统一社会信用代码"></af-table-column>
                    <af-table-column prop="certifieddate" label="认证时间"></af-table-column>
                    <af-table-column prop="form" label="剂型"></af-table-column>
                  </el-table>
                </div>
              </div>
            </div>
            <div class="addRightBox" v-else>
              <!--下载 -->
              <div class="rightCenter">
                <div class="centerTit">通过《药品生产质量管理规范》认证的企业</div>
                <div class="centerCon">
                  <div class="no">
                    <span></span>
                  </div>
                  <div class="excel" @click="downloadTable('10')">
                    <img src="@/assets/img/Excel.png" alt />
                    下载数据到Excel
                  </div>
                </div>
              </div>
              <!-- 表格 -->
              <div class="rightBottom">
                <div class="tabulationBottom">
                  <el-table :data="tableList" style="width: 100%" border size="mini">
                    <af-table-column prop="time" fixed label="时间"></af-table-column>
                    <af-table-column prop="no" fixed label="证书编号"></af-table-column>
                    <af-table-column prop="enterprisename" fixed label="企业名称"></af-table-column>
                    <af-table-column prop="unifiedSocialCreditCode" label="统一社会信用代码"></af-table-column>
                    <af-table-column prop="scope" label="认证范围"></af-table-column>
                    <af-table-column prop="certifiedDate" label="认证日期"></af-table-column>
                    <af-table-column prop="validity" label="有效日期"></af-table-column>
                  </el-table>
                </div>
              </div>
            </div>

            <!-- 分页 -->
            <div class="rightPaging">
              <el-pagination
                prev-text="上一页"
                next-text="下一页"
                background
                @current-change="handleCurrentChange"
                :current-page="currentPage4"
                :page-size="limit"
                layout="total, prev, pager, next, jumper"
                :total="totlalCount"
              ></el-pagination>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>
<script>
import Header from "@/components/header2";
import Footer from "@/components/footer2";
import rightTop from "@/components/rightTop";
import magic from "@/../static/common/magic.js";
import api from "@/../static/common/api/api.js";
window.api = api;
import $ from "jquery";
import axios from "axios";

export default {
  props: {},
  components: {
    Header,
    Footer,
    rightTop
  },
  data() {
    return {
      companyName: "",
      openeds: ["one"], //导航栏展开

      // 右侧的
      categoryId: "",
      creditCode: this.$route.query.creditCode,
      offset: 0, //从多少条开始
      limit: 10, //每页多少条
      currentPage4: 1,
      totlalCount: 0, //总条数

      tableList: [] //表格数据
    };
  },
  computed: {},
  methods: {
    // 库 上市
    intoMarket() {
      this.$router.push({
        path: "/upmarket",
        query: {
          dbcode: 2
        }
      });
    },
    // 库 医药
    medical() {
      this.$router.push({
        path: "/pharma",
        query: {
          dbcode: 1
        }
      });
    },
    //显示公司名
    companyNameFun() {
      let companyName = JSON.parse(sessionStorage.getItem("companyName"));
      this.companyName = companyName;
    },
    // 导航菜单切换页面
    showPage(val) {
      this.categoryId = val;
    },

    // 首次展示有数据-
    firstShowPage() {
      let categoryId = ["10", "9", "8", "7", "6", "5", "4", "3", "2", "1"];
      categoryId.forEach(item => {
        let parmars = {
          categoryId: item,
          creditCode: this.creditCode,
          offset: this.offset,
          limit: this.limit
        };
        api.entireGetData(parmars).then(res => {
          if (res.data.total != 0) {
            // console.log(item,111111111111111)
            return (this.categoryId = item);
          } else {
            this.categoryId == "1";
          }
        });
      });
    },
    // { "categoryId":"","creditCode":"915101832024104543","offset":0,"limit":10}
    // 表格
    getShowData(categoryId, creditCode, offset, limit) {
      let parmars = {
        categoryId,
        creditCode,
        offset,
        limit
      };
      // console.log(categoryId, "id呀");
      api.entireGetData(parmars).then(res => {
        this.totlalCount = res.data.total;
        this.tableList = res.data.rows;
        // console.log(res.data, "大数据");
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.offset = (val - 1) * this.limit;
      this.getShowData(
        this.categoryId,
        this.creditCode,
        this.offset,
        this.limit
      );
    },
    // 下载
    downloadTable(val) {
      // console.log(val, "是你吗");
      axios({
        method: "post",
        url: window.medicineUrl + "/medicineShow/downShowData", // 请求地址
        data: {
          categoryId: val,
          creditCode: this.creditCode,
          offset: this.offset,
          limit: this.limit
        },
        responseType: "arraybuffer",
        observe: "response"
      }).then(res => {
        if (val == "1") {
          const fileName = "化学药品制剂主要品种产量.xlsx";
          let blob = new Blob([res.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          if ("download" in document.createElement("a")) {
            // 非IE下载
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName);
          }
        } else if (val == "2") {
          const fileName = "化学制药中间体品种产量、出口量.xlsx";
          let blob = new Blob([res.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          if ("download" in document.createElement("a")) {
            // 非IE下载
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName);
          }
        } else if (val == "3") {
          const fileName = "化学原料药二十四大类品种产量、出口量.xlsx";
          let blob = new Blob([res.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          if ("download" in document.createElement("a")) {
            // 非IE下载
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName);
          }
        } else if (val == "4") {
          const fileName = "中药生物制药主要品种产量.xlsx";
          let blob = new Blob([res.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          if ("download" in document.createElement("a")) {
            // 非IE下载
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName);
          }
        } else if (val == "5") {
          const fileName = "医药器械主要品种产量.xlsx";
          let blob = new Blob([res.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          if ("download" in document.createElement("a")) {
            // 非IE下载
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName);
          }
        } else if (val == "6") {
          const fileName = "NMPA批准的境内第三类医疗器械.xlsx";
          let blob = new Blob([res.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          if ("download" in document.createElement("a")) {
            // 非IE下载
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName);
          }
        } else if (val == "7") {
          const fileName = "批准新药.xlsx";
          let blob = new Blob([res.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          if ("download" in document.createElement("a")) {
            // 非IE下载
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName);
          }
        } else if (val == "8") {
          const fileName = "医药企业信息.xlsx";
          let blob = new Blob([res.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          if ("download" in document.createElement("a")) {
            // 非IE下载
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName);
          }
        } else if (val == "9") {
          const fileName = "通过制剂国际认证的企业.xlsx";
          let blob = new Blob([res.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          if ("download" in document.createElement("a")) {
            // 非IE下载
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName);
          }
        } else {
          const fileName = "通过《药品生产质量管理规范》认证的企业.xlsx";
          let blob = new Blob([res.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          if ("download" in document.createElement("a")) {
            // 非IE下载
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName);
          }
        }
      });
      // 埋点
      try {
        //LogCollection.contents["key"]="value";
        //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
        //2：收藏
        //3：下载
        //4：分享
        //5：购买
        //6：登录
        //7：注册
        //9：搜索
        //10：复制
        //11：点赞
        //12：评论
        LogCollection.send(3);
      } catch (e) {}
    },
    download(data) {
      if (!data) {
        return;
      }
      let url = window.URL.createObjectURL(new Blob([data]));
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", "excel.xlsx");
      document.body.appendChild(link);
      link.click();
    },
    collapseChage() {
      this.collapse = !this.collapse;
    }
  },
  created() {},
  mounted() {
    this.firstShowPage(); //首次展示有数据
    this.companyNameFun(); //显示公司名
  },
  watch: {
    categoryId: function(newval, oldval) {
      this.getShowData(newval, this.creditCode, this.offset, this.limit); //表格
    }
  }
};
</script>
<style scoped lang="less">
// 右侧的
@import "../../assets/less/style.less";
@import "../../assets/less/medicineRight.less";
@import "../../assets/less/tableScrollbar.less";
.stockApp {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
}
.stock {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
main {
  width: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  background: url("../../assets/img/bg.png") no-repeat top;
  .mainTop {
    width: 100%;
    height: 50px;
    line-height: 50px;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #5e6064;
    padding-left: 20px;
    span {
      cursor: pointer;
    }
    span:hover {
      color: #3583ed;
    }
  }
  .mainBottom {
    width: 100%;
    flex-grow: 1;
    display: flex;
    justify-content: space-between;
    // 左侧菜单栏
    .left {
      width: 240px;
      height: auto;
      min-height: 80vh;
      margin-right: 23px;
      .leftBox {
        width: auto;
        height: auto;

        border: 1px solid #08396a;
        .headline {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #dfecf7;
        }
        .el-menu {
          border-right: none;
          padding: 0 10px;
          box-sizing: border-box;
        }
        /deep/ .el-submenu__icon-arrow {
          right: 2px;
        }
        /deep/ .el-submenu__title {
          padding: 0;
          padding-left: 5px !important;
        }
        .el-submenu .el-menu-item {
          padding-left: 25px !important;
          padding: 0px;
          display: inline-block;
          width: 200px;
          color: #dfecf7;
        }
        /deep/ .el-submenu__title:hover {
          background-color: transparent !important;
        }
        .el-menu-item:hover {
          background-color: transparent !important;
        }
        .is-active {
          color: #409eff !important;
        }
        #moreText {
          padding-top: 6px;
          line-height: 20px;
          word-wrap: break-word;
          word-break: break-all;
          white-space: normal;
        }
      }
    }
  }
}
/deep/ .el-table th {
  display: table-cell !important; //表头对齐
}
/deep/ .el-table__empty-block {
  background: #052b4f;
}
/deep/ .el-menu {
  background: #052b4f;
}
</style>
 


// WEBPACK FOOTER //
// src/view/medicine/index.vue